import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
  Spinner
} from "@material-tailwind/react";
import { Axios } from '../Axios/Axios';
import FullScreenSpinner from '../Spinner/FullScreenSpinner';

import noProducts from '../../uploads/No-products.png';

import './Products.css';

const axios = new Axios();

export default function Products({ filter_values, moreProducts, onPaginationChange, filtered_products }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showButton, setShowButton] = useState(moreProducts || true);
  const [offset, setOffset] = useState(0);
  const limit = 20;
  const [isLoaded, setIsLoaded] = useState({});
  const [filterValues, setFilterValues] = useState({});

  useEffect(() => {
    if (filtered_products) {
      setProducts(filtered_products);
    }
  }, [filtered_products]);

  useEffect(() => {
    setOffset(0);
  }, [filter_values]);  

  useEffect(() => {
    setLoading(true);
    setFilterValues(filter_values);
    let url = `api/home?limit=${limit}&offset=${offset}`;
  
    const fetchData = async () => {
      try {
        let response;
        if (Object.keys(filter_values).length === 0) {
          response = await axios.get(url);
        } else {
          if (offset !== 0) { 
            response = await axios.post('api/home/filter', { limit, offset, filter_values });
          }
        }
        if (offset === 0 && response === undefined) {
          setShowButton(moreProducts)
        }else{
          if (response.status === 200) {
            setProducts(prev => (offset === 0 ? response.data : [...prev, ...response.data]));
            setShowButton(response.data.length >= limit);
          }
        }
      } catch (error) {
        console.log(error);
        setShowButton(false);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [offset]);

  useEffect(() => {
    if (onPaginationChange) {
      onPaginationChange(offset, limit);
    }
  }, [offset, limit, onPaginationChange]);

  const handleLoadMore = () => {
    setOffset(prevOffset => prevOffset + limit);
  };

  const handleCardClick = (product) => {
    navigate(`/производ/${product.id}`, { state: { product } });
  };

  const handleImageLoad = (id) => {
    setIsLoaded(prevState => ({ ...prevState, [id]: true }));
  };

  const handleImageError = (id) => {
    setIsLoaded(prevState => ({ ...prevState, [id]: true }));  // Set to true even on error to avoid stuck state
  };

  return (
    <div className="w-full">
        {products.length === 0 ? (
          <div className="w-full text-center py-10">
            <Typography color="gray" className="font-semibold text-xl">
                Нема производи за прикажување.
            </Typography>
              <img src={noProducts} alt="No products" className="w-1/3 sm:w-1/5 mx-auto mt-20" />
          </div>
        ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((product) => (
            <Card key={product.id} className="w-full flex flex-col h-full">
              <CardHeader shadow={false} floated={false} className="h-54 sm:h-96 md:h-56 lg:h-44 xl:h-44 2xl:h-72">
                {!isLoaded[product.id] && (
                  <div className="absolute inset-0 flex items-center justify-center bg-gray-200">
                    <Spinner />
                  </div>
                )}
                <img
                  src={`https://samsung-climatesolutions.com${product.image_url}`}
                  alt={product.name}
                  onLoad={() => handleImageLoad(product.id)}
                  onError={() => handleImageError(product.id)}
                  className={`h-full w-full object-scale-down ${isLoaded[product.id] ? "opacity-100" : "opacity-0"}`}
                />
              </CardHeader>
              <div className="flex-grow flex flex-col">
                <CardBody className="flex-grow">
                  <Typography color="blue-gray" className="font-bold text-xl">
                    {product.name}
                  </Typography>
                  <Typography variant="small" color="gray" className="font-normal mb-2">
                    {product.category} | {product.sub_category}
                  </Typography>
                  <Typography variant="small" color="gray" className="font-normal mb-2">
                    {product.compatible_models && (
                      <span className="text-gray-400 font-medium text-base">Компатибилно со: </span>
                    )}
                    {product.compatible_models}
                  </Typography>
                  <Typography color="blue-gray" className="font-normal text-sm">
                    <span className="text-gray-400 font-medium text-base">Капацитет:</span> {product.capacities}
                  </Typography>
                </CardBody>
                <CardFooter className="mt-auto pt-0">
                  <div className="mb-5">
                    <Typography color="blue-gray" className="font-semibold text-base">
                      {product.tags}
                    </Typography>
                  </div>
                  <Button
                    style={{ background: "#f7f7f7" }}
                    ripple={false}
                    fullWidth={true}
                    onClick={() => handleCardClick(product)}
                    className="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg shadow-gray-900/10 hover:shadow-gray-900/20 focus:opacity-[0.85] active:opacity-[0.85] active:shadow-none block w-full bg-blue-gray-900/10 text-blue-gray-900 shadow-none hover:scale-105 hover:shadow-none focus:scale-105 focus:shadow-none active:scale-100"
                  >
                    Повеќе детали
                  </Button>
                </CardFooter>
              </div>
            </Card>
          ))}
        </div>
        )}
      {showButton && (
        <div className="mt-10 text-center">
          <Button
            type="button"
            onClick={handleLoadMore}
            className="m-auto"
            style={{ width: '150px' }}
          >
            Load more
          </Button>
        </div>
      )}
      <FullScreenSpinner display={loading} />
    </div>
  );  
}
